/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import { FieldSlider } from '@blockly/field-slider';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';
import { Display7SegmentsModal } from './customBlocks/display7SegmentsModal';
import { defaultPinDigit, defaultPinSegment } from './customBlocks/display7SegmentsData';

Blockly.Blocks.COPA_initial_block = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput();
    this.appendStatementInput('Start');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setTooltip('Inicio');
  },
};

Blockly.Blocks.COPA_codigo_initial_block = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput();
    this.appendStatementInput('Start');
    this.setPreviousStatement(false);
    this.setNextStatement(false);
    this.setTooltip('Inicio');
  },
};

// Las opciones de los dropdowns van en texto literal a propósito: en prod sus claves de lang
// no existen y siempre se muestra este fallback.
Blockly.Blocks.COPA_nanobot_turn = {
  init: function () {
    this.setColour(colors.COLOUR_SERVO);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/nanorobot.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_NANOBOT_TURN);
    this.appendValueInput('angulo').setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('PIN1').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_NANOBOT_DIRECTION)
      .appendField(new Blockly.FieldDropdown([
        ['horario', '0'],
        ['antihorario', '1'],
      ]), 'NPIN1');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_COPA_NANOBOT_TURN_TOOLTIP);
  },
};

Blockly.Blocks.COPA_shoot_antigen = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/nanorobot.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_SHOOT_ANTIGEN)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'],
      ]), 'NPIN1');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_COPA_SHOOT_ANTIGEN_TOOLTIP);
  },
};

Blockly.Blocks.COPA_identify_agent = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/agente_viral.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_IDENTIFY_AGENT)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'],
      ]), 'NPIN1');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_COPA_IDENTIFY_AGENT_TOOLTIP);
  },
};

Blockly.Blocks.COPA_evaluate_position = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/agente_viral.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_EVALUATE_POSITION)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'],
      ]), 'NPIN1');
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_COPA_EVALUATE_POSITION_TOOLTIP);
  },
};

Blockly.Blocks.COPA_shoot_special_antigen = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/coparobotica/nanorobot.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('PIN1').setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_SHOOT_SPECIAL_ANTIGEN)
      .appendField(new Blockly.FieldDropdown([
        ['1', '1'], ['2', '2'], ['3', '3'], ['4', '4'],
      ]), 'NPIN1');
    this.appendValueInput('NUM')
      .setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(Blockly.Msg.LANG_COPA_SHOOT_SPECIAL_ANTIGEN_POSITION);
    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setTooltip(Blockly.Msg.LANG_COPA_SHOOT_SPECIAL_ANTIGEN_TOOLTIP);
  },
};

// Sin el mutator math_number_minmax_mutator del legacy: en v13 FieldSlider ya persiste su valor.
Blockly.Blocks.math_number_minmax_copa_agent_position = {
  init: function () {
    this.setColour(colors.COLOUR_MATH);
    this.setOutput(true, Number);
    this.appendDummyInput()
      .appendField(new FieldSlider(10, 10, 170, 1), 'SLIDER');
    this.setInputsInline(true);
    this.setTooltip(Blockly.Msg.LANG_MATH_NUMBER_TOOLTIP);
  },
};

Blockly.Blocks.display_7segments = {
  init: function () {
    this.setColour(colors.COLOUR_LCD);
    this.appendDummyInput('').appendField('Display 7 Segmentos');
    this.appendDummyInput()
      .setAlign(Blockly.inputs.Align.CENTRE)
      .appendField(new Display7SegmentsModal(
        { pinDigit: defaultPinDigit(), pinSegment: defaultPinSegment() },
        undefined,
        {},
      ), 'DISPLAY');
    this.setInputsInline(false);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
  },
};
